import React from "react";
import { Routes, Route } from "react-router-dom";

import Integration from "./integration";
import NewIntegration from "./newIntegrationForm";
import IntegrationsList from "/app/src/components/generic/components/integration/integrationsView";
import Controls from "/app/src/components/generic/components/integration/_controls";
import { useToggle } from "/app/src/hooks";
import { App } from "/app/src/models";

/**
 * Renders the OrderProcessorApp component establishing routes for managing integrations.
 *
 * @param {{ app: App }} props - Component props.
 * @param {App} props.app - The main application instance.
 * @returns {JSX.Element} React element containing the app routes.
 */
export default function OrderProcessorApp({ app }: { app: App }) {
  const [toggled, setToggled] = useToggle();

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Controls
            app={app}
            name="order_builder_app"
            toggled={toggled}
            setToggled={setToggled}
          >
            <NewIntegration app={app} setToggled={setToggled} />
          </Controls>
        }
      >
        <Route
          path="integrations/:integrationId/*"
          element={<Integration app={app} />}
        />
        <Route
          path="/"
          element={<IntegrationsList includeType={false} app={app} />}
        />
      </Route>
    </Routes>
  );
}
